/**
 * @class Oskari.userinterface.request.UpdateExtensionRequest
 */
Oskari.clazz.define('Oskari.userinterface.request.UpdateExtensionRequest', function (extension, state, extensionName, extensionTop, extensionLeft) {
  this._extension = extension;
  this._state = state;
  this._extensionName = extensionName;
  this._location = {};
  this._location.top = extensionTop;
  this._location.left = extensionLeft;
}, {
  __name: 'userinterface.UpdateExtensionRequest',
  getName: function getName() {
    return this.__name;
  },
  getExtension: function getExtension() {
    return this._extension;
  },
  getState: function getState() {
    return this._state;
  },
  getExtensionName: function getExtensionName() {
    return this._extensionName;
  },
  getExtensionLocation: function getExtensionLocation() {
    return this._location;
  }
}, {
  'protocol': ['Oskari.mapframework.request.Request']
});